import {
  type GridRenderCellParams,
  GridRowReorderCell,
  gridSortModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';

export const ReorderCellWithSortTooltip = (params: GridRenderCellParams) => {
  const apiRef = useGridApiContext();
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  const { t } = useTranslation();

  if (params.rowNode.type === 'footer' || params.rowNode.type === 'pinnedRow') {
    return null;
  }

  const isSorted = sortModel.length > 0;

  if (!isSorted) {
    return <GridRowReorderCell {...params} />;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex size-full items-center justify-center">
          <GridRowReorderCell {...params} />
        </div>
      </TooltipTrigger>
      <TooltipContent>{t(($) => $.views.table.reorderDisabledWhenSorted)}</TooltipContent>
    </Tooltip>
  );
};
